import { useRouteMatch } from 'react-router-dom';
import { skipToken } from '@reduxjs/toolkit/dist/query';

import { useFetchSubmissionQuery } from 'app/apis/reviews';

/**
 * Hook to get isCrossLangReview status from the current submission.
 */
export const useIsCrossLangReview = (submissionId?: number): boolean => {
  const match = useRouteMatch<{ submissionId: string }>('/project-reviews/:submissionId');
  const routeSubmissionId = Number(match?.params.submissionId) || undefined;
  const targetSubmissionId = submissionId ?? routeSubmissionId;

  const { data: submission } = useFetchSubmissionQuery(targetSubmissionId ?? skipToken);

  return !!submission?.crossLangReview;
};
